module.exports = __webpack_public_path__ + "static/manjgura-bw-2acc7ab342f58772d719ab4024063a0d.jpg";